import { deleteApi, get, post } from "../GenericServices";

const ContractualRevenue = {
  saveNewContractualRevenue: (data) => {
    return post(`contractual-revenue`, data);
  },
  saveDocumentContractualRevenue: (id, file) => {
    return post(`contractual-revenue/${id}/document`, file);
  },
  getDocumentContractualRevenue: (id) => {
    return get(`contractual-revenue/${id}/document`);
  },
  deleteContractualRevenue: (id) => {
    return deleteApi(`contractual-revenue/${id}`);
  },
};

export default ContractualRevenue;
